export enum ScenarioApprovalType
{
	None = 0,
	Request = 1,
	Allocation = 2,
	Both = 4
}